import {
    mixinLangDictionaries
} from "../../funcs";
import LangDictionary from "./LangDictionary";
// RUS
import RU_LANG_TEXTS from "./ru/texts";
import RU_ERROR_CODES from "./ru/error_codes";
import RU_TABLE_NAMES from "./ru/table_names";
import RU_FIELD_NAME from "./ru/field_name";
import RU_ICON_TITLES from "./ru/icon_titles";
import RU_REPORT_TITLES from "./ru/report_titles";
import RU_MONTH_NAME from "./ru/month_name";
import RU_FORMS from "./ru/forms";
import RU_APPS from "./ru/apps";
// ENG
import EN_LANG_TEXTS from "./en/texts";
import EN_ERROR_CODES from "./en/error_codes";
import EN_TABLE_NAMES from "./en/table_names";
import EN_FIELD_NAME from "./en/field_name";
import EN_ICON_TITLES from "./en/icon_titles";
import EN_REPORT_TITLES from "./en/report_titles";
import EN_MONTH_NAME from "./en/month_name";
import EN_FORMS from "./en/forms";
import EN_APPS from "./en/apps";

let langDictionary;

const getLangDictionary = (context) => {
    initLang(context);
    return langDictionary;
};


const initLang = (context) => {
    const lang = window.lang || "ru";

    // base dictionary for langDictionary.get(key, scope)
    let LANG_TEXTS;
    if ( lang == "ru" ) {
        LANG_TEXTS = RU_LANG_TEXTS;
    }
    else {
        // ENG до конца не переведен, поэтому подставляем русские названия,
        // там где нет перевода
        EN_LANG_TEXTS = mixinLangDictionaries(RU_LANG_TEXTS, EN_LANG_TEXTS);
        LANG_TEXTS = EN_LANG_TEXTS;
    }
    langDictionary = new LangDictionary(LANG_TEXTS, lang);

    if ( context ) {
        context.setLangOptions(
            langDictionary._data,
            lang
        );
    }

    if ( lang == "ru" ) {

        // columns
        langDictionary.addFields(RU_FIELD_NAME);
        // forms
        langDictionary.addForms(RU_FORMS);

        langDictionary.setLangObjects({
            FIELD_NAME: langDictionary.FIELD_NAME, // columns
            FORMS: langDictionary.FORMS, // forms
            ERROR_CODES: RU_ERROR_CODES,
            TABLE_NAMES: RU_TABLE_NAMES,
            ICON_TITLES: RU_ICON_TITLES,
            REPORT_TITLES: RU_REPORT_TITLES,
            MONTH_NAME: RU_MONTH_NAME,
            APPS: RU_APPS
        });
    }
    else {
        // ENG до конца не переведен, поэтому подставляем русские названия,
        // там где нет перевода
        EN_ERROR_CODES = mixinLangDictionaries(RU_ERROR_CODES, EN_ERROR_CODES);
        EN_TABLE_NAMES = mixinLangDictionaries(RU_TABLE_NAMES, EN_TABLE_NAMES);
        EN_FIELD_NAME = mixinLangDictionaries(RU_FIELD_NAME, EN_FIELD_NAME);
        EN_ICON_TITLES = mixinLangDictionaries(RU_ICON_TITLES, EN_ICON_TITLES);
        EN_REPORT_TITLES = mixinLangDictionaries(RU_REPORT_TITLES, EN_REPORT_TITLES);
        EN_FORMS = mixinLangDictionaries(RU_FORMS, EN_FORMS);
        EN_APPS = mixinLangDictionaries(RU_APPS, EN_APPS);

        // columns
        langDictionary.addFields(EN_FIELD_NAME);
        // forms
        langDictionary.addForms(EN_FORMS);

        langDictionary.setLangObjects({
            FIELD_NAME: langDictionary.FIELD_NAME, // columns
            FORMS: langDictionary.FORMS, // forms
            ERROR_CODES: EN_ERROR_CODES,
            TABLE_NAMES: EN_TABLE_NAMES,
            ICON_TITLES: EN_ICON_TITLES,
            REPORT_TITLES: EN_REPORT_TITLES,
            MONTH_NAME: EN_MONTH_NAME,
            APPS: EN_APPS
        });
    }

    if ( context ) {

        context.setLangObjects({
            FIELD_NAME: langDictionary.FIELD_NAME, // columns
            FORMS: langDictionary.FORMS, // forms
            ERROR_CODES: langDictionary.ERROR_CODES,
            TABLE_NAMES: langDictionary.TABLE_NAMES,
            ICON_TITLES: langDictionary.ICON_TITLES,
            REPORT_TITLES: langDictionary.REPORT_TITLES,
            MONTH_NAME: langDictionary.MONTH_NAME,
            APPS: langDictionary.APPS,
            MENU: langDictionary.MENU
        });
    }

    langDictionary.reInitLang = getLangDictionary.bind(this, langDictionary);
    langDictionary.getEnTranslation = () => {

        return {
            FIELD_NAME: EN_FIELD_NAME, // columns
            FORMS: EN_FORMS, // forms
            ERROR_CODES: EN_ERROR_CODES,
            TABLE_NAMES: EN_TABLE_NAMES,
            ICON_TITLES: EN_ICON_TITLES,
            REPORT_TITLES: EN_REPORT_TITLES,
            MONTH_NAME: EN_MONTH_NAME,
            APPS: EN_APPS,
            _data: EN_LANG_TEXTS
        };
    };
};


initLang();


export default langDictionary;
